import { FormDialog } from "@dzambalaorg/mui-dialog-form";
import { SelectInput, TextInput } from "@dzambalaorg/mui-inputs-core";
import { AvatarInput } from "@dzambalaorg/mui-inputs-image-firebase";
import { IMutationProps, useDialogForm } from "@dzambalaorg/react-hooks";
import { ContractStatus, IContract } from "@framework/types";
import { BlockchainInfoPopover } from "@framework/shared";

import { validationSchema } from "./validation";

export interface IPredictionContractDialogFormProps
  extends IMutationProps,
    Pick<ReturnType<typeof useDialogForm>, "mode"> {
  open: boolean;
  selectedItem: IContract | null;
}

export const PredictionContractDialogForm = (props: IPredictionContractDialogFormProps) => {
  const { selectedItem, open, mode, ...rest } = props;

  if (!open || !selectedItem) {
    return null;
  }

  const { id, title, imageUrl, contractStatus, description, address, contractFeatures } = selectedItem;

  const fixedValues = {
    id,
    title,
    address,
    imageUrl,
    description,
    contractStatus,
    contractFeatures,
  };

  return (
    <FormDialog
      open={open}
      initialValues={fixedValues}
      validationSchema={validationSchema}
      message={`dialogs.${mode}`}
      testId="PredictionContractEditForm"
      action={id ? <BlockchainInfoPopover address={address} contractFeatures={contractFeatures} /> : null}
      filter={({ title, description, imageUrl, contractStatus }) => ({
        title,
        description,
        imageUrl,
        contractStatus,
      })}
      {...rest}
    >
      <TextInput name="title" />
      <SelectInput name="contractStatus" options={ContractStatus} disabledOptions={[ContractStatus.NEW]} />
      <AvatarInput name="imageUrl" />
    </FormDialog>
  );
};
